"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrangleAbilityHandler = exports.StrangleActorAbilityFactory = exports.StrangleAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Stun_1 = require("../../core/effects/core/Stun");
const Registries_1 = require("../../core/state/Registries");
class StrangleAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Strangle;
        this.__typeName = "Strangle";
    }
}
exports.StrangleAbilityArgs = StrangleAbilityArgs;
let StrangleActorAbilityFactory = class StrangleActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Strangle", "OneEnemies", 2);
    }
};
StrangleActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Strangle")
], StrangleActorAbilityFactory);
exports.StrangleActorAbilityFactory = StrangleActorAbilityFactory;
let StrangleAbilityHandler = class StrangleAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 70)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new Stun_1.StunEffectArgs(),
                    duration: Duration_1.Duration.Turns(2),
                    sequence
                });
            }
        });
    }
};
StrangleAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Strangle)
], StrangleAbilityHandler);
exports.StrangleAbilityHandler = StrangleAbilityHandler;
